<script lang="ts">
  let {
    recFrequency = $bindable<"daily" | "weekly" | "monthly" | "yearly">("monthly"),
    recInterval  = $bindable(1),
    recEndAt     = $bindable(""),
  } = $props<{
    recFrequency: "daily" | "weekly" | "monthly" | "yearly";
    recInterval:  number;
    recEndAt:     string;
  }>();
</script>

<div class="grid grid-cols-1 sm:grid-cols-3 gap-3 divider pt-3">
  <div>
    <label class="label" for="rf">Frequência</label>
    <select id="rf" class="input" bind:value={recFrequency}>
      <option value="daily">Diária</option>
      <option value="weekly">Semanal</option>
      <option value="monthly">Mensal</option>
      <option value="yearly">Anual</option>
    </select>
  </div>
  <div>
    <label class="label" for="ri">A cada</label>
    <input id="ri" type="number" min="1" max="365" class="input" bind:value={recInterval} />
  </div>
  <div>
    <label class="label" for="re">Termina em (opcional)</label>
    <input id="re" type="date" class="input" bind:value={recEndAt} />
  </div>
  <p class="text-xs text-muted col-span-full">
    💡 A primeira ocorrência é criada agora e o sistema gera as próximas automaticamente.
  </p>
</div>
